<template>
  <div class="baidu-map-template">
    <div class="map-main-container" v-show="hasData">
      <!-- 左边 -->
      <div class="aside aside-left">
        <!-- 当前坐标 -->
        <div class="current-address">
          <h2 class="sec-title">当前坐标</h2>
          <p class="address">{{ address }}</p>
          <p>经度：{{ currCoordinate.lng }}</p>
          <p>纬度：{{ currCoordinate.lat }}</p>
        </div>
        <!-- 市场因素 -->
        <div class="market-factors">
          <h2 class="sec-title">市场因素</h2>
          <h3>司法拍卖</h3>
          <!--<p class="avg-price-label">最近一次成交均价</p>-->
          <p class="avg-price">
            <span class="label">最近一次成交均价</span>
            <span class="price">{{ avgPrice.justice.latelyaverageprice }}</span>
          </p>
          <p class="avg-price">
            <span class="label">最近六个月成交均价</span>
            <span class="price">{{ avgPrice.justice.sixmonaverageprice }}</span>
          </p>
          <p class="avg-price">
            <span class="label">历史全部成交均价</span>
            <span class="price">{{ avgPrice.justice.averageprice }}</span>
          </p>
          <h3 style="margin-top:20px">房产交易</h3>
          <p class="avg-price">
            <span class="label">最近一次成交均价</span>
            <span class="price">{{
              avgPrice.houseProperty.latelyaverageprice
            }}</span>
          </p>
          <p class="avg-price">
            <span class="label">最近六个月成交均价</span>
            <span class="price">{{
              avgPrice.houseProperty.sixmonaverageprice
            }}</span>
          </p>
          <p class="avg-price">
            <span class="label">历史全部成交均价</span>
            <span class="price">{{ avgPrice.houseProperty.averageprice }}</span>
          </p>
        </div>
        <!-- <input type="button" onclick="add_overlay();" value="添加覆盖物" />
        <input type="button" onclick="remove_overlay();" value="删除覆盖物" /> -->
      </div>
      <!-- 中间 -->
      <div class="aside aside-center">
        <!--<div id="allmap"></div>-->
        <baidu-map
          class="map"
          :center="mapConfig.center"
          :zoom="mapConfig.zoom"
          :scroll-wheel-zoom="mapConfig.scrollWheelZoom"
          ref="map"
          v-if="isMapShow"
          @ready="readyMap"
        >
          <!-- 中心点 -->
          <bm-marker :position="mapConfig.center" :dragging="false">
            <!--<bm-label content="我爱北京天安门" :labelStyle="{color: 'red', fontSize : '24px'}" :offset="{width: -35, height: 30}"/>-->
          </bm-marker>
          <!-- 范围圈 -->
          <bm-circle
            :center="mapConfig.circlePath.center"
            :radius="mapConfig.circlePath.radius"
            :stroke-color="mapConfig.circlePath.strokeColor"
            :stroke-opacity="0.4"
            :stroke-weight="2"
            :fill-color="mapConfig.circlePath.fillColor"
            :fill-opacity="0.5"
            :editing="false"
          ></bm-circle>
          <!-- 周围标签 -->
          <bm-marker
            :position="item.position"
            v-for="item in coordinates"
            :icon="mapConfig.icon"
          >
            <bm-label
              :content="item.label"
              :labelStyle="mapConfig.labelStyle"
              :offset="{ width: -35, height: 30 }"
            />
          </bm-marker>
        </baidu-map>
      </div>
      <!-- 右边 -->
      <div class="aside aside-right">
        <!-- 列表 -->
        <list
          ref="list"
          :address="address"
          v-show="isListStatus"
          @on-update-list="updateList"
          @on-show-detail="showDetail"
        />
        <!-- 详情 -->
        <detail
          ref="listDetail"
          @on-show-list="showList"
          @on-update-coordinate="updateCenterCoordinate"
        />
      </div>
    </div>
    <div class="node-data" v-show="!hasData">
      暂无数据
    </div>
  </div>
</template>

<script>
import listTemplate from "./list";
import detailTemplate from "./detail";

export default {
  components: {
    list: listTemplate,
    detail: detailTemplate
  },
  props: {
    // 担保物类型
    pmObjectType: {
      required: true
    },
    // 位置
    address: {
      default: ""
    },
    // 模式 (show || hide-then-show)
    mode: {
      default: "show"
    }
  },
  data() {
    return {
      // 地图配置
      mapConfig: {
        center: { lng: 0, lat: 0 },
        zoom: 3,
        scrollWheelZoom: true, // 是否开启滚轮缩放
        // 范围（圆圈）
        circlePath: {
          center: { lng: 0, lat: 0 },
          radius: 5000,
          strokeColor: "#a0b1e8",
          fillColor: "#528cd9"
        },
        // 标签样式
        icon: {
          url: require("@/assets/img/icons/localicon.png"),
          size: { width: 1, height: 1 }
        },
        labelStyle: {
          padding: "0px",
          color: "#333",
          border: "solid 1px #8ba2b9"
        }
      },
      coordinates: [],
      map: "",
      BMap: "",
      // 当前坐标
      currCoordinate: {
        lng: "",
        lat: ""
      },
      // 均价
      avgPrice: {
        justice: {
          latelyaverageprice: "",
          sixmonaverageprice: "",
          averageprice: ""
        },
        houseProperty: {
          latelyaverageprice: "",
          sixmonaverageprice: "",
          averageprice: ""
        }
      },
      // 是否是列表状态
      isListStatus: true,
      // 是否显示地图
      isMapShow: true,
      // 是否有数据
      hasData: true
    };
  },
  watch: {
    async pmObjectType(val) {
      console.log(val);
      // let checked = false;
      //
      // if (val !== "") {
      //   checked = await this.getMapAuthByPmType(val);
      // }
      //
      // if (!checked) return;
      // 验证是否有地图状态
      // if (val) {
      //   this.hasData = await this.getMapAuthByPmType(val);
      // } else {
      //   this.hasData = false;
      //   return;
      // }
      // if (!this.hasData) return;
      //
      // this.getLitiAvg(this.address);
      // this.getEstateAvg(this.address);
      //
      // let { lng, lat } = await this.getCoodinate(this.address);
      // this.currCoordinate["lng"] = lng;
      // this.currCoordinate["lat"] = lat;
      //
      // // 创建地图
      // // this.initMap();
      // if (this.isMapShow) {
      //   this.createMap();
      // }
    }
  },
  created() {
    // this.isMapShow = this.mode === "show";
  },
  methods: {
    // 展示
    async show(address) {
      this.hasData = true;
      if (!this.hasData) return;

      this.getLitiAvg(address);
      this.getEstateAvg(address);

      // 获取数据
      this.$refs.list.search(address);

      let { lng, lat } = await this.getCoodinate(address);
      this.currCoordinate["lng"] = lng;
      this.currCoordinate["lat"] = lat;

      // 创建地图
      // this.initMap();
      this.createMap();
    },

    // 根据担保物类型判断是否有权调用地图接口
    getMapAuthByPmType(pmObjectType) {
      return new Promise((resolve, reject) => {
        const param = { pm_object_type: pmObjectType };
        this.$request.map_getValuationStatus(param).then(res => {
          if (res.code !== 0) {
            this.$Message.error(res.msg);
            reject(false);
          }
          resolve(res.valuationStatus);
        });
      });
    },

    /**
     * 获取坐标
     * @param {string} address 地址
     */
    getCoodinate(address) {
      return new Promise((resolve, reject) => {
        const param = { address };
        this.$request.map_getCoodinate(param).then(res => {
          if (res.code !== 0) {
            this.$Message.error(res.msg);
            reject(false);
          }

          let { cur_lng, cur_lat } = res.data;
          resolve({ lng: cur_lng, lat: cur_lat });
        });
      });
    },

    // 获取司法拍卖均价
    getLitiAvg(address) {
      const param = { keyword: address };
      this.$request.map_getLitiAvg(param).then(res => {
        if (res.code !== 0) {
          this.$Message.error(res.msg);
          return;
        }

        let { latelyaverageprice, sixmonaverageprice, averageprice } = res.avg;
        this.avgPrice.justice.latelyaverageprice =
          latelyaverageprice || "查询无数据";
        this.avgPrice.justice.sixmonaverageprice =
          sixmonaverageprice || "查询无数据";
        this.avgPrice.justice.averageprice = averageprice || "查询无数据";
      });
    },

    // 获取房产交易均价
    getEstateAvg(address) {
      const param = { keyword: address };
      this.$request.map_getEstateAvg(param).then(res => {
        if (res.code !== 0) {
          this.$Message.error(res.msg);
          return;
        }

        let { latelyaverageprice, sixmonaverageprice, averageprice } = res.avg;
        this.avgPrice.houseProperty.latelyaverageprice =
          latelyaverageprice || "查询无数据";
        this.avgPrice.houseProperty.sixmonaverageprice =
          sixmonaverageprice || "查询无数据";
        this.avgPrice.houseProperty.averageprice = averageprice || "查询无数据";
      });
    },

    // 展示详情
    showDetail({ type, id }) {
      this.isListStatus = false;
      this.$refs.listDetail.search(type, id);
    },

    // 展示列表
    showList() {
      this.isListStatus = true;
      this.updateCenterCoordinate({
        lng: this.currCoordinate.lng,
        lat: this.currCoordinate.lat
      });
    },

    // 更新列表坐标
    updateList(list) {
      this.coordinates = list.map((item, index) => {
        let { lng, lat, averageprice, assetname, title } = item;
        let price = averageprice ? `￥${averageprice}/m2` : "暂无均价";
        return {
          position: { lng, lat },
          label: `${price}<span style="background: #3385ff; color: #fff; padding: 0 4px; margin-left: 4px;">${index +
            1}</span>`,
          name: assetname || title
        };
      });
    },

    // 更新中心点位置
    updateCenterCoordinate({ lng, lat }) {
      // this.mapConfig.center.lng = lng;
      // this.mapConfig.center.lat = lat;
      this.mapConfig.circlePath.center.lng = lng;
      this.mapConfig.circlePath.center.lat = lat;
    },

    // 准备绘制地图
    readyMap({ BMap, map }) {
      this.map = map;
      this.BMap = BMap;
      this.createMap();
    },

    // 创建地图
    async createMap() {
      let { lng, lat } = this.currCoordinate;

      // 中心点坐标
      this.mapConfig.center.lng = lng;
      this.mapConfig.center.lat = lat;
      this.mapConfig.zoom = 13;

      // 范围
      this.mapConfig.circlePath.center.lng = lng;
      this.mapConfig.circlePath.center.lat = lat;
    },

    // 更新地图
    updateMap() {
      this.isMapShow = true;
    },

    // 清空
    clear() {}
  }
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
